import { ActionCreator } from "easy-peasy";

import { AppContextRole } from "../types";
import { useStoreActions, useStoreState } from "../store";

function useAppContextRole(): [AppContextRole, ActionCreator<AppContextRole>] {
  const appContextRole = useStoreState((state) => state.preferences.role);
  const setAppContextRole = useStoreActions(
    (actions) => actions.preferences.setRole
  );

  return [appContextRole, setAppContextRole];
}

export default useAppContextRole;
